<template>
  <div>
    <!-- 力を発揮する場面 -->
    <div
      v-show="situation"
      id="situation"
      class="mb-md-12 mb-10"
    >
      <div class="subheading mb-7">
        <span class="subheading-dot" />
        <span class="subheading-text">
          {{ t("scenes_of_strength") }}
        </span>
      </div>
      <div class="border-none p-0">
        <span
          class="word-pre-wrap font-middle preview-text"
          v-text="situation"
        />
      </div>
    </div>
    <!-- 得意分野 -->
    <div
      v-show="hasSpecialty"
      id="specialty"
      class="mb-md-11 mb-3"
    >
      <div class="subheading mb-6">
        <span class="subheading-dot" />
        <span class="subheading-text">
          {{ t("specialty") }}
        </span>
      </div>
      <table class="table mb-0">
        <tbody>
          <tr
            v-show="industries.length"
            id="industry"
            class="mb-md-1"
          >
            <th
              scope="row"
              class="variable-width text-black bg-gray01 vertical-middle px-3 py-xl-2 py-md-4 py-1"
            >
              {{ t("industry") }}
            </th>
            <td class="text-black vertical-middle w-100">
              <span>
                {{ industries.join("、") }}
              </span>
            </td>
          </tr>
          <tr
            v-show="serviceTypes.length"
            id="service-types"
            class="mb-md-1"
          >
            <th
              scope="row"
              class="variable-width text-black bg-gray01 vertical-middle px-3 py-xl-2 py-md-4 py-1"
            >
              {{ t("business_area") }}
            </th>
            <td class="text-black vertical-middle w-100">
              <span>
                {{ serviceTypes.join("、") }}
              </span>
            </td>
          </tr>
          <tr
            v-show="projectThemes.length"
            id="project-themes"
            class="mb-md-1"
          >
            <th
              scope="row"
              class="variable-width text-black bg-gray01 vertical-middle px-3 py-xl-2 py-md-4 py-1"
            >
              <span class="d-inline-block">{{ t("project_style") + "・" }}</span>
              <span class="d-inline-block">{{ t("phase") }}</span>
            </th>
            <td class="text-black vertical-middle w-100">
              <span>
                {{ projectThemes.join("、") }}
              </span>
            </td>
          </tr>
          <tr
            v-show="customerTypes.length"
            id="customer-types"
            class="mb-md-1"
          >
            <th
              scope="row"
              class="variable-width text-black bg-gray01 vertical-middle px-3 py-xl-2 py-md-4 py-1"
            >
              {{ t("customer") + t("type") }}
            </th>
            <td class="text-black vertical-middle w-100">
              <span>
                {{ customerTypes.join("、") }}
              </span>
            </td>
          </tr>
          <tr
            v-show="purposeTags.length"
            id="purpose-tags"
            class="mb-md-1"
          >
            <th
              scope="row"
              class="variable-width text-black bg-gray01 vertical-middle px-3 py-xl-2 py-md-4 py-1"
            >
              {{ t("task") + "・" + t("theme") }}
            </th>
            <td class="text-black vertical-middle w-100">
              <span>
                {{ purposeTags.join("、") }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    industries: {
      type: Array,
      default() {
        return [];
      }
    },
    purposeTags: {
      type: Array,
      default() {
        return [];
      }
    },
    serviceTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    customerTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    projectThemes: {
      type: Array,
      default() {
        return [];
      }
    },
    situation: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasSpecialty() {
      return this.industries.length || this.purposeTags.length || this.serviceTypes.length || this.customerTypes.length || this.projectThemes.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.font-middle {
  line-height: 28.8px;
}
table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0 0.5rem;
  th,
  td {
    border: none;
    overflow-wrap: break-word;
  }
  th {
    font-size: 1rem;
    font-weight: bold;
  }
  th:not(:last-child) {
    width: 155px;
  }
  td {
    font-size: 1.142rem;
    font-weight: 500;
    padding: 0.25rem 0 0.25rem 1.5rem;
  }
}
@media screen and (max-width: 767px) {
  table {
    th,
    td {
      display: block;
    }
    td {
      padding: 1rem;
      padding-bottom: 2.5rem;
      border: none;
    }
    th:not(:last-child) {
      width: 100%;
    }
  }
}
</style>
